import React from "react";
export default (function () {
    return React.createElement("footer", null);
});
